import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

function Whychooseecommerce() {
  return (
    <section
      className="trusted_ecommerce_web ecommerce_why_choose text p-100"
      style={{ background: "#fff" }}
    >
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <h2>Custom Fintech Solutions We Deliver</h2>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="mt-3 mt-md-0">
            <p>
              From payment apps to enterprise-level financial monitoring
              systems, as a reputable fintech software development company,
              TekRevol boasts technical expertise to support fintech ventures of
              all sizes.
            </p>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <Row className="mt-3 mt-md-5">
              <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-4">
                <div className="trusted_ecomm_box">
                  <div className="ecomm_title">01</div>
                  <div className="ecomm_box_content">
                    <h5>Digital Banking Solutions</h5>
                    <p>
                      We design innovative banking solutions that enable users
                      to manage their finances, streamline key operations, and
                      enhance overall baking experiences while meeting the
                      demands of modern banking.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-4">
                <div className="trusted_ecomm_box">
                  <div className="ecomm_title">02</div>
                  <div className="ecomm_box_content">
                    <h5>Data Analytics Systems</h5>
                    <p>
                      Leverage Data Analytics, deep learning, and AI/ML
                      expertise of our FinTech software developers who design
                      complex data analytics platforms that turn customer data
                      and market trends into actionable insights.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-4">
                <div className="trusted_ecomm_box">
                  <div className="ecomm_title">03</div>
                  <div className="ecomm_box_content">
                    <h5>Payment Processing Systems</h5>
                    <p>
                      We build secure and user-friendly payment processing
                      systems, such as P2P money transfer applications, payment
                      solutions, and DeFi wallets, ensuring secure transaction
                      processing and compliance.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-4">
                <div className="trusted_ecomm_box">
                  <div className="ecomm_title">04</div>
                  <div className="ecomm_box_content">
                    <h5>Wealth Management Solutions</h5>
                    <p>
                      We offer comprehensive wealth management solutions that
                      involve advanced analytics and have user-friendly
                      interfaces that help users track, manage, and grow their
                      assets and achieve their financial goals.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-4">
                <div className="trusted_ecomm_box">
                  <div className="ecomm_title">05</div>
                  <div className="ecomm_box_content">
                    <h5>Regtech Solutions</h5>
                    <p>
                      We develop Regtech solutions that ensure regulatory
                      compliance and risk management through tools that help
                      organizations minimize their risk in terms of compliance
                      and find ways through the complexities of regulations.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-4">
                <div className="trusted_ecomm_box">
                  <div className="ecomm_title">06</div>
                  <div className="ecomm_box_content">
                    <h5>InsurTech Solutions</h5>
                    <p>
                      Our team of fintech software developers develops
                      user-friendly and scalable InsurTech solutions to
                      streamline claim management, ensure secure payment options
                      for insurance, and improve user experiences in general.
                    </p>
                  </div>
                </div>
              </Col>

              <Col
                xs={12}
                md={6}
                lg={6}
                xl={4}
                xxl={4}
                className="mb-xl-0 mb-4"
              >
                <div className="trusted_ecomm_box">
                  <div className="ecomm_title">07</div>
                  <div className="ecomm_box_content">
                    <h5>Financial Fraud Detection Systems</h5>
                    <p>
                      We help financial institutions detect and prevent fraud by
                      developing highly sophisticated fraud detection systems
                      that use AI-based algorithms and ML to check pattern
                      identification, anomaly, and data protection.
                    </p>
                  </div>
                </div>
              </Col>
              <Col
                xs={12}
                md={6}
                lg={6}
                xl={4}
                xxl={4}
                className="mb-xl-0 mb-4"
              >
                <div className="trusted_ecomm_box">
                  <div className="ecomm_title">08</div>
                  <div className="ecomm_box_content">
                    <h5>Cryptocurrency and Blockchain Solutions</h5>
                    <p>
                      Our future-ready fintech software development services
                      develop innovative cryptocurrency and{" "}
                      <Link to="/blockchain-development-company"></Link>
                      blockchain solutions that provide greater security and
                      transparency so that we can address the unique challenges
                      of the financial landscape more effectively.
                    </p>
                  </div>
                </div>
              </Col>

              <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                <div className="trusted_ecomm_box">
                  <div className="ecomm_title">09</div>
                  <div className="ecomm_box_content">
                    <h5>AI-Powered Financial Assistants</h5>
                    <p>
                      Our fintech development services develop AI-based
                      financial assistants specifically tailored for the BFSI
                      sector to enhance customer engagement and streamline
                      financial management among users on various platforms.
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Whychooseecommerce;
